export enum ConsentStatus {
  Granted = 'granted',
  Denied = 'denied'
}

export enum ConsentStorageType {
  Ad = 'ad_storage',
  Analytics = 'analytics_storage',
  Functionality = 'functionality_storage',
  Personalization = 'personalization_storage',
  Security = 'security_storage',
  AdUserData = 'ad_user_data',
  AdPersonalization = 'ad_personalization',
}

export enum AnalyticsEventName {
  PageView = 'page_view',
  RequestCtaClick = 'request_cta_click',
  ApplicationCtaClick = 'application_cta_click',
  EmailClick = 'email_click',
  PhoneClick = 'phone_click',
  LinkedinClick = 'linkedin_click',
  FacebookClick = 'facebook_click',
  AuctionsSpecialOfferCarouselSwipe = 'auctions_special_offer_carousel_swipe',
  AuctionsSpecialOfferClick = 'auctions_special_offer_click',
  AuctionsSpecialOfferDetailsClick = 'auctions_special_offer_details_click',
  AuctionsSpecialOfferFormSubmit = 'auctions_special_offer_form_submit',
  AuctionsContactFormSubmit = 'auctions_contact_form_submit',
  AutoparkContactFormSubmit = 'autopark_contact_form_submit',
  PhoneBannerShown = 'phone_banner_shown',
  PhoneBannerClick = 'phone_banner_click',
  PhoneBannerClose = 'phone_banner_close',
  PhoneBannerReject = 'phone_banner_reject',
}

export enum AnalyticsEventCategory {
  CTA = 'cta_click',
  SocialClick = 'social_click',
  Contact = 'contact_click',
  Carousel = 'carousel',
  SpecialOffer = 'special_offer',
  ContactForm = 'contact_form',
  PhoneBanner = 'phone_banner',
  RouteEvent = 'routes'
}

export interface AnalyticsEvent {
  event: AnalyticsEventName;
  eventCategory: AnalyticsEventCategory;
  eventPayload?: any;
}

export type ConsentStructure = Record<ConsentStorageType, ConsentStatus>;

export enum FormEventSendResult {
  Success = 'form_send_success',
  Error = 'form_send_error'
}
